__turbopack_context__.v({
  "isMobile": "unavailable-site-poster-module__AcT8sG__isMobile",
  "pattern": "unavailable-site-poster-module__AcT8sG__pattern",
  "posterWrapper": "unavailable-site-poster-module__AcT8sG__posterWrapper",
  "title": "unavailable-site-poster-module__AcT8sG__title",
});
